import { axios } from 'lib/axios';
import { useQuery } from 'react-query';

export const getMyChecklist = () => {
  return axios.get('/duedeligences/checklist');
};

export const useMyChecklist = ({ config } = {}) => {
  return useQuery({
    ...config,
    queryKey: ['myChecklist'],
    queryFn: () => getMyChecklist(),
  });
};
